import Ajax from '@utils/ajax';

export default {
  get(user, options = {}) {
    return Ajax.get({
      url: `/users/${user.id}/group_collection`,
      ...options,
    });
  },

  create(data, options = {}) {
    return Ajax.post({
      url: `/users/x/group_collection`,
      data: data,
      ...options,
    });
  },

  update(groupCollection, data, options = {}) {
    return Ajax.post({
      url: `/users/x/group_collection/${groupCollection.id}`,
      data: { group_collection: data, _method: 'PATCH' },
      ...options,
    });
  },

  updateSortOrder(user, data, options = {}) {
    return Ajax.post({
      url: `/users/${user.id}/group_collection/update_sort_order`,
      data: { sort_order: JSON.stringify(data), _method: 'PATCH' },
      ...options,
    });
  },

  destroy(collection, data, options = {}) {
    return Ajax.post({
      url: `/users/x/group_collection/${collection.id}`,
      data: { ...data, _method: 'DELETE' },
      ...options,
    });
  },
};
